import React, { useState } from "react";
import { Stack, Text, Paper, Space, Box, Title, Divider } from "@mantine/core";
import { EventDate, EventLocation } from "../components/EventDateLocation";

export const EventDetails = () => {
  return (
    <>
      {/* Header Section */}
      <Paper
        withBorder
        shadow="md"
        p="xl"
        radius="md"
        style={{
          backgroundColor: "white",
          textAlign: "center",
        }}
      >
        <Title order={2} c="dark" fw={700} mb="sm">
          Event Details
        </Title>
        <Text size="md" c="dimmed">
          Join us to celebrate this special occasion! Here’s everything you need to know.
        </Text>
      </Paper>

      <Space h="xl" />

      {/* Details Section */}
      <Paper
        withBorder
        shadow="md"
        p="xl"
        radius="md"
        style={{
          backgroundColor: "white",
        }}
      >
        <Stack gap="lg" align="center">
          {/* Date & Time */}
          <Box>
            <Text size="lg" fw={700} ta="center" mb="xs">
              📅 Date & Time
            </Text>
            <EventDate />
          </Box>

          <Divider style={{ width: "60%" }} />

          {/* Location */}
          <Box>
            <Text size="lg" fw={700} ta="center" mb="xs">
              📍 Location
            </Text>
            <EventLocation />
          </Box>

          <Divider style={{ width: "60%" }} />

          {/* Hosts */}
          <Box>
            <Text size="lg" fw={700} ta="center" mb="xs">
              🎉 Hosted By
            </Text>
            <Text size="md" ta="center">
              Susan Hendrickson, Mathew Potter, and Faye Taggart
            </Text>
          </Box>

          <Divider style={{ width: "60%" }} />

          {/* Contact Info */}
          <Box>
            <Text size="lg" fw={700} ta="center" mb="xs">
              📞 Contact
            </Text>
            <Text size="md" ta="center">
              Have questions? Reach out to{" "}
              <Text
                component="a"
                href="tel:+14036128797"
                fw={700}
                c="#7fac9d"
                style={{ textDecoration: "none" }}
              >
                Susan Hendrickson at (403) 612-8797
              </Text>
            </Text>
          </Box>
        </Stack>
      </Paper>
    </>
  );
};
